export const FETCH_TEMPLATES_BEGIN = "FETCH_TEMPLATES_BEGIN";
export const FETCH_TEMPLATES_SUCCESS = "FETCH_TEMPLATES_SUCCESS";
export const FETCH_TEMPLATES_FAILURE = "FETCH_TEMPLATES_FAILURE";
export const OPEN_CREATE_TEMPLATE_MODAL = "OPEN_CREATE_TEMPLATE_MODAL";
export const CLOSE_CREATE_TEMPLATE_MODAL = "CLOSE_CREATE_TEMPLATE_MODAL";
